module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-fr1.567fefb.png";